import {
  type CancelledOrder,
  type CheckoutQuery,
  type HighFrequency_AddOnRestriction,
  type HighFrequency_AddOnRestriction_ExcludeSelectedNumbers,
  HighFrequency_AddOnRestrictionType,
  type OrderPollQuery,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

type CheckoutPayment = CheckoutQuery['checkout']['payment']
type CheckoutPayWithTopUp = Extract<CheckoutPayment, { __typename: 'PayWithTopUp' }>

export const isCancelledOrder = (order: OrderPollQuery['order']): order is CancelledOrder => {
  const cancelledOrder = order as CancelledOrder
  return cancelledOrder?.cancelReasonType !== undefined
}

export const isPayWithTopUp = (pay: CheckoutPayment | undefined): pay is CheckoutPayWithTopUp =>
  pay?.__typename === 'PayWithTopUp'

export const isEProtectResponseSuccess = (
  response: LooseObject,
): response is EProtectResponseSuccess => {
  const responseSuccess = response as EProtectResponseSuccess
  return responseSuccess.paypageRegistrationId !== undefined && responseSuccess.type !== undefined
}

export const isHighFrequencyAddOnExcludeSelectedNumbers = (
  restriction: HighFrequency_AddOnRestriction,
): restriction is HighFrequency_AddOnRestriction_ExcludeSelectedNumbers =>
  restriction.type === HighFrequency_AddOnRestrictionType.ExcludeSelectedNumbers
